import ServiceCRUD from '../../../../../services/ServiceGasOrder';

class FamilyService extends ServiceCRUD {
  constructor() {
    super(`/api/familias-dos-produtos`);
  }
}

export default new FamilyService();
